import { HttpResponse, http } from "msw";
import { PlessService } from "../../../app/shared/pless-service.model";
import { GetBundleCatalogMediumResponse } from "src/app/kymw/kymw71/kwmy7100/api-services/get-bundle-catalog-medium.service";
import { RegistBundleCatalogRoundInfoResponse } from "src/app/kymw/kymw71/kwmy7100/api-services/regist-bundle-catalog-round-info.service";
import { GetBundleCatalogRoundInfoResponse } from "src/app/kymw/kymw71/kwmy7100/api-services/get-bundle-catalog-round-info.service";

interface Response<T> {
  status: string,
  message: string,
  result?: {
    obj: T;
  };
}

export const kymw71Handlers = [
  http.post(
    PlessService.SERVICE.getBundleCatalogMedium.url,
    () => {
      return HttpResponse.json(getBundleCatalogMediumResponse);
    }
  ),
  http.post(
    PlessService.SERVICE.getBundleCatalogRoundInfo.url,
    () => {
      return HttpResponse.json(getBundleCatalogRoundInfo);
    }
  ),
  http.post(
    PlessService.SERVICE.registBundleCatalogRoundInfo.url,
    async ({ request }) => {
      console.log('req', await request.json());
      return HttpResponse.json(registBundleCatalogRoundInfoResponse);
    }
  ),
  http.post(
    PlessService.SERVICE.deleteBundleCatalogRoundInfo.url,
    async ({ request }) => {
      console.log('req', await request.json());
      return HttpResponse.json(deleteBundleCatalogRoundInfo);
    }
  )
];

const getBundleCatalogMediumResponse: Response<GetBundleCatalogMediumResponse> = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        MediumType: '041',
        MediumName: 'いつでも注文　食品'
      },
      {
        MediumType: '065',
        MediumName: '予約商品'
      }
    ]
  }
};

const getBundleCatalogRoundInfo: Response<GetBundleCatalogRoundInfoResponse> = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        BundleCatalogRoundId: '4',
        MediumType: '041',
        MediumName: 'いつでも注文　食品',
        StartOrderCode: '2025200',
        EndOrderCode: '2025320',
        StartDelivCatalogId: '20250801',
        EndDelivCatalogId: '20251004',
        BundleCatalogRoundName: 'いつ注（８～１０月）',
        BundleCatalogRoundCode: '2025200-2025320',
        EndDelivCatalogEndDate: '20251004'
      },
      {
        BundleCatalogRoundId: '3',
        MediumType: '041',
        MediumName: 'いつでも注文　食品',
        StartOrderCode: '2025160',
        EndOrderCode: '2025190',
        StartDelivCatalogId: '20250701',
        EndDelivCatalogId: '20250704',
        BundleCatalogRoundName: 'いつ注（７月）',
        BundleCatalogRoundCode: '2025160-2025190',
        EndDelivCatalogEndDate: '20250704'
      },
      {
        BundleCatalogRoundId: '2',
        MediumType: '065',
        MediumName: '予約商品',
        StartOrderCode: '2025160',
        EndOrderCode: '2025320',
        StartDelivCatalogId: '20250701',
        EndDelivCatalogId: '20251004',
        BundleCatalogRoundName: '予約商品（７～１０月）',
        BundleCatalogRoundCode: '2025030-2025150',
        EndDelivCatalogEndDate: '20251220'
      },
      {
        BundleCatalogRoundId: '1',
        MediumType: '065',
        MediumName: '予約商品',
        StartOrderCode: '2023160',
        EndOrderCode: '2023320',
        StartDelivCatalogId: '20230701',
        EndDelivCatalogId: '20231004',
        BundleCatalogRoundName: '予約商品（７～１０月）',
        BundleCatalogRoundCode: '2023030-2023150',
        EndDelivCatalogEndDate: '20241220'
      },
      // {
      //   BundleCatalogRoundId: '1',
      //   MediumType: '065',
      //   MediumName: 'ｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗ',
      //   StartOrderCode: '2023160',
      //   EndOrderCode: '2023320',
      //   StartDelivCatalogId: '20230701',
      //   EndDelivCatalogId: '20231004',
      //   BundleCatalogRoundName: 'ｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗｗ',
      //   BundleCatalogRoundCode: '2023030-2023150',
      //   EndDelivCatalogEndDate: '20241220'
      // },
      // {
      //   BundleCatalogRoundId: '1',
      //   MediumType: '065',
      //   MediumName: '髙﨑😀<>',
      //   StartOrderCode: '2023160',
      //   EndOrderCode: '2023320',
      //   StartDelivCatalogId: '20230701',
      //   EndDelivCatalogId: '20231004',
      //   BundleCatalogRoundName: '髙﨑😀<>',
      //   BundleCatalogRoundCode: '2023030-2023150',
      //   EndDelivCatalogEndDate: '20241220'
      // },
      // {
      //   BundleCatalogRoundId: '1',
      //   MediumType: '065',
      //   MediumName: '予約商品',
      //   StartOrderCode: '2023160',
      //   EndOrderCode: '2023320',
      //   StartDelivCatalogId: '20230701',
      //   EndDelivCatalogId: '20231004',
      //   BundleCatalogRoundName: '予約商品（７～１０月）',
      //   BundleCatalogRoundCode: '2023030-2023150',
      //   EndDelivCatalogEndDate: '20241220'
      // },
      // {
      //   BundleCatalogRoundId: '1',
      //   MediumType: '065',
      //   MediumName: '予約商品',
      //   StartOrderCode: '2023160',
      //   EndOrderCode: '2023320',
      //   StartDelivCatalogId: '20230701',
      //   EndDelivCatalogId: '20231004',
      //   BundleCatalogRoundName: '予約商品（７～１０月）',
      //   BundleCatalogRoundCode: '2023030-2023150',
      //   EndDelivCatalogEndDate: '20241220'
      // },
      // {
      //   BundleCatalogRoundId: '1',
      //   MediumType: '065',
      //   MediumName: '予約商品',
      //   StartOrderCode: '2023160',
      //   EndOrderCode: '2023320',
      //   StartDelivCatalogId: '20230701',
      //   EndDelivCatalogId: '20231004',
      //   BundleCatalogRoundName: '予約商品（７～１０月）',
      //   BundleCatalogRoundCode: '2023030-2023150',
      //   EndDelivCatalogEndDate: '20241220'
      // },
      // {
      //   BundleCatalogRoundId: '1',
      //   MediumType: '065',
      //   MediumName: '予約商品',
      //   StartOrderCode: '2023160',
      //   EndOrderCode: '2023320',
      //   StartDelivCatalogId: '20230701',
      //   EndDelivCatalogId: '20231004',
      //   BundleCatalogRoundName: '予約商品（７～１０月）',
      //   BundleCatalogRoundCode: '2023030-2023150',
      //   EndDelivCatalogEndDate: '20241220'
      // },
      // {
      //   BundleCatalogRoundId: '1',
      //   MediumType: '065',
      //   MediumName: '予約商品',
      //   StartOrderCode: '2023160',
      //   EndOrderCode: '2023320',
      //   StartDelivCatalogId: '20230701',
      //   EndDelivCatalogId: '20231004',
      //   BundleCatalogRoundName: '予約商品（７～１０月）',
      //   BundleCatalogRoundCode: '2023030-2023150',
      //   EndDelivCatalogEndDate: '20241220'
      // },
      // {
      //   BundleCatalogRoundId: '1',
      //   MediumType: '065',
      //   MediumName: '予約商品',
      //   StartOrderCode: '2023160',
      //   EndOrderCode: '2023320',
      //   StartDelivCatalogId: '20230701',
      //   EndDelivCatalogId: '20231004',
      //   BundleCatalogRoundName: '予約商品（７～１０月）',
      //   BundleCatalogRoundCode: '2023030-2023150',
      //   EndDelivCatalogEndDate: '20241220'
      // },
      // {
      //   BundleCatalogRoundId: '1',
      //   MediumType: '065',
      //   MediumName: '予約商品',
      //   StartOrderCode: '2023160',
      //   EndOrderCode: '2023320',
      //   StartDelivCatalogId: '20230701',
      //   EndDelivCatalogId: '20231004',
      //   BundleCatalogRoundName: '予約商品（７～１０月）',
      //   BundleCatalogRoundCode: '2023030-2023150',
      //   EndDelivCatalogEndDate: '20241220'
      // },
      // {
      //   BundleCatalogRoundId: '1',
      //   MediumType: '065',
      //   MediumName: '予約商品',
      //   StartOrderCode: '2023160',
      //   EndOrderCode: '2023320',
      //   StartDelivCatalogId: '20230701',
      //   EndDelivCatalogId: '20231004',
      //   BundleCatalogRoundName: '予約商品（７～１０月）',
      //   BundleCatalogRoundCode: '2023030-2023150',
      //   EndDelivCatalogEndDate: '20241220'
      // },
      // {
      //   BundleCatalogRoundId: '1',
      //   MediumType: '065',
      //   MediumName: '予約商品',
      //   StartOrderCode: '2023160',
      //   EndOrderCode: '2023320',
      //   StartDelivCatalogId: '20230701',
      //   EndDelivCatalogId: '20231004',
      //   BundleCatalogRoundName: '予約商品（７～１０月）',
      //   BundleCatalogRoundCode: '2023030-2023150',
      //   EndDelivCatalogEndDate: '20241220'
      // },
      // {
      //   BundleCatalogRoundId: '1',
      //   MediumType: '065',
      //   MediumName: '予約商品',
      //   StartOrderCode: '2023160',
      //   EndOrderCode: '2023320',
      //   StartDelivCatalogId: '20230701',
      //   EndDelivCatalogId: '20231004',
      //   BundleCatalogRoundName: '予約商品（７～１０月）',
      //   BundleCatalogRoundCode: '2023030-2023150',
      //   EndDelivCatalogEndDate: '20241220'
      // },
      // {
      //   BundleCatalogRoundId: '1',
      //   MediumType: '065',
      //   MediumName: '予約商品',
      //   StartOrderCode: '2023160',
      //   EndOrderCode: '2023320',
      //   StartDelivCatalogId: '20230701',
      //   EndDelivCatalogId: '20231004',
      //   BundleCatalogRoundName: '予約商品（７～１０月）',
      //   BundleCatalogRoundCode: '2023030-2023150',
      //   EndDelivCatalogEndDate: '20241220'
      // },
      // {
      //   BundleCatalogRoundId: '1',
      //   MediumType: '065',
      //   MediumName: '予約商品',
      //   StartOrderCode: '2023160',
      //   EndOrderCode: '2023320',
      //   StartDelivCatalogId: '20230701',
      //   EndDelivCatalogId: '20231004',
      //   BundleCatalogRoundName: '予約商品（７～１０月）',
      //   BundleCatalogRoundCode: '2023030-2023150',
      //   EndDelivCatalogEndDate: '20241220'
      // },
      // {
      //   BundleCatalogRoundId: '1',
      //   MediumType: '065',
      //   MediumName: '予約商品',
      //   StartOrderCode: '2023160',
      //   EndOrderCode: '2023320',
      //   StartDelivCatalogId: '20230701',
      //   EndDelivCatalogId: '20231004',
      //   BundleCatalogRoundName: '予約商品（７～１０月）',
      //   BundleCatalogRoundCode: '2023030-2023150',
      //   EndDelivCatalogEndDate: '20241220'
      // },
      // {
      //   BundleCatalogRoundId: '1',
      //   MediumType: '065',
      //   MediumName: '予約商品',
      //   StartOrderCode: '2023160',
      //   EndOrderCode: '2023320',
      //   StartDelivCatalogId: '20230701',
      //   EndDelivCatalogId: '20231004',
      //   BundleCatalogRoundName: '予約商品（７～１０月）',
      //   BundleCatalogRoundCode: '2023030-2023150',
      //   EndDelivCatalogEndDate: '20241220'
      // },
      // {
      //   BundleCatalogRoundId: '1',
      //   MediumType: '065',
      //   MediumName: '予約商品',
      //   StartOrderCode: '2023160',
      //   EndOrderCode: '2023320',
      //   StartDelivCatalogId: '20230701',
      //   EndDelivCatalogId: '20231004',
      //   BundleCatalogRoundName: '予約商品（７～１０月）',
      //   BundleCatalogRoundCode: '2023030-2023150',
      //   EndDelivCatalogEndDate: '20241220'
      // },
      // {
      //   BundleCatalogRoundId: '1',
      //   MediumType: '065',
      //   MediumName: '予約商品',
      //   StartOrderCode: '2023160',
      //   EndOrderCode: '2023320',
      //   StartDelivCatalogId: '20230701',
      //   EndDelivCatalogId: '20231004',
      //   BundleCatalogRoundName: '予約商品（７～１０月）',
      //   BundleCatalogRoundCode: '2023030-2023150',
      //   EndDelivCatalogEndDate: '20241220'
      // },
      // {
      //   BundleCatalogRoundId: '1',
      //   MediumType: '065',
      //   MediumName: '予約商品',
      //   StartOrderCode: '2023160',
      //   EndOrderCode: '2023320',
      //   StartDelivCatalogId: '20230701',
      //   EndDelivCatalogId: '20231004',
      //   BundleCatalogRoundName: '予約商品（７～１０月）',
      //   BundleCatalogRoundCode: '2023030-2023150',
      //   EndDelivCatalogEndDate: '20241220'
      // },
      // {
      //   BundleCatalogRoundId: '1',
      //   MediumType: '065',
      //   MediumName: '予約商品',
      //   StartOrderCode: '2023160',
      //   EndOrderCode: '2023320',
      //   StartDelivCatalogId: '20230701',
      //   EndDelivCatalogId: '20231004',
      //   BundleCatalogRoundName: '予約商品（７～１０月）',
      //   BundleCatalogRoundCode: '2023030-2023150',
      //   EndDelivCatalogEndDate: '20241220'
      // },
      // {
      //   BundleCatalogRoundId: '1',
      //   MediumType: '065',
      //   MediumName: '予約商品',
      //   StartOrderCode: '2023160',
      //   EndOrderCode: '2023320',
      //   StartDelivCatalogId: '20230701',
      //   EndDelivCatalogId: '20231004',
      //   BundleCatalogRoundName: '予約商品（７～１０月）',
      //   BundleCatalogRoundCode: '2023030-2023150',
      //   EndDelivCatalogEndDate: '20241220'
      // },
      // {
      //   BundleCatalogRoundId: '1',
      //   MediumType: '065',
      //   MediumName: '予約商品',
      //   StartOrderCode: '2023160',
      //   EndOrderCode: '2023320',
      //   StartDelivCatalogId: '20230701',
      //   EndDelivCatalogId: '20231004',
      //   BundleCatalogRoundName: '予約商品（７～１０月）',
      //   BundleCatalogRoundCode: '2023030-2023150',
      //   EndDelivCatalogEndDate: '20241220'
      // },
      // {
      //   BundleCatalogRoundId: '1',
      //   MediumType: '065',
      //   MediumName: '予約商品',
      //   StartOrderCode: '2023160',
      //   EndOrderCode: '2023320',
      //   StartDelivCatalogId: '20230701',
      //   EndDelivCatalogId: '20231004',
      //   BundleCatalogRoundName: '予約商品（７～１０月）',
      //   BundleCatalogRoundCode: '2023030-2023150',
      //   EndDelivCatalogEndDate: '20241220'
      // },
      // {
      //   BundleCatalogRoundId: '1',
      //   MediumType: '065',
      //   MediumName: '予約商品',
      //   StartOrderCode: '2023160',
      //   EndOrderCode: '2023320',
      //   StartDelivCatalogId: '20230701',
      //   EndDelivCatalogId: '20231004',
      //   BundleCatalogRoundName: '予約商品（７～１０月）',
      //   BundleCatalogRoundCode: '2023030-2023150',
      //   EndDelivCatalogEndDate: '20241220'
      // },
      // {
      //   BundleCatalogRoundId: '1',
      //   MediumType: '065',
      //   MediumName: '予約商品',
      //   StartOrderCode: '2023160',
      //   EndOrderCode: '2023320',
      //   StartDelivCatalogId: '20230701',
      //   EndDelivCatalogId: '20231004',
      //   BundleCatalogRoundName: '予約商品（７～１０月）',
      //   BundleCatalogRoundCode: '2023030-2023150',
      //   EndDelivCatalogEndDate: '20241220'
      // },
      // {
      //   BundleCatalogRoundId: '1',
      //   MediumType: '065',
      //   MediumName: '予約商品',
      //   StartOrderCode: '2023160',
      //   EndOrderCode: '2023320',
      //   StartDelivCatalogId: '20230701',
      //   EndDelivCatalogId: '20231004',
      //   BundleCatalogRoundName: '予約商品（７～１０月）',
      //   BundleCatalogRoundCode: '2023030-2023150',
      //   EndDelivCatalogEndDate: '20241220'
      // },
      // {
      //   BundleCatalogRoundId: '1',
      //   MediumType: '065',
      //   MediumName: '予約商品',
      //   StartOrderCode: '2023160',
      //   EndOrderCode: '2023320',
      //   StartDelivCatalogId: '20230701',
      //   EndDelivCatalogId: '20231004',
      //   BundleCatalogRoundName: '予約商品（７～１０月）',
      //   BundleCatalogRoundCode: '2023030-2023150',
      //   EndDelivCatalogEndDate: '20241220'
      // },
      // {
      //   BundleCatalogRoundId: '1',
      //   MediumType: '065',
      //   MediumName: '予約商品',
      //   StartOrderCode: '2023160',
      //   EndOrderCode: '2023320',
      //   StartDelivCatalogId: '20230701',
      //   EndDelivCatalogId: '20231004',
      //   BundleCatalogRoundName: '予約商品（７～１０月）',
      //   BundleCatalogRoundCode: '2023030-2023150',
      //   EndDelivCatalogEndDate: '20241220'
      // },
      // {
      //   BundleCatalogRoundId: '1',
      //   MediumType: '065',
      //   MediumName: '予約商品',
      //   StartOrderCode: '2023160',
      //   EndOrderCode: '2023320',
      //   StartDelivCatalogId: '20230701',
      //   EndDelivCatalogId: '20231004',
      //   BundleCatalogRoundName: '予約商品（７～１０月）',
      //   BundleCatalogRoundCode: '2023030-2023150',
      //   EndDelivCatalogEndDate: '20241220'
      // },
      // {
      //   BundleCatalogRoundId: '1',
      //   MediumType: '065',
      //   MediumName: '予約商品',
      //   StartOrderCode: '2023160',
      //   EndOrderCode: '2023320',
      //   StartDelivCatalogId: '20230701',
      //   EndDelivCatalogId: '20231004',
      //   BundleCatalogRoundName: '予約商品（７～１０月）',
      //   BundleCatalogRoundCode: '2023030-2023150',
      //   EndDelivCatalogEndDate: '20241220'
      // },
      // {
      //   BundleCatalogRoundId: '1',
      //   MediumType: '065',
      //   MediumName: '予約商品',
      //   StartOrderCode: '2023160',
      //   EndOrderCode: '2023320',
      //   StartDelivCatalogId: '20230701',
      //   EndDelivCatalogId: '20231004',
      //   BundleCatalogRoundName: '予約商品（７～１０月）',
      //   BundleCatalogRoundCode: '2023030-2023150',
      //   EndDelivCatalogEndDate: '20241220'
      // },
      // {
      //   BundleCatalogRoundId: '1',
      //   MediumType: '065',
      //   MediumName: '予約商品',
      //   StartOrderCode: '2023160',
      //   EndOrderCode: '2023320',
      //   StartDelivCatalogId: '20230701',
      //   EndDelivCatalogId: '20231004',
      //   BundleCatalogRoundName: '予約商品（７～１０月）',
      //   BundleCatalogRoundCode: '2023030-2023150',
      //   EndDelivCatalogEndDate: '20241220'
      // },
      // {
      //   BundleCatalogRoundId: '1',
      //   MediumType: '065',
      //   MediumName: '予約商品',
      //   StartOrderCode: '2023160',
      //   EndOrderCode: '2023320',
      //   StartDelivCatalogId: '20230701',
      //   EndDelivCatalogId: '20231004',
      //   BundleCatalogRoundName: '予約商品（７～１０月）',
      //   BundleCatalogRoundCode: '2023030-2023150',
      //   EndDelivCatalogEndDate: '20241220'
      // },
      // {
      //   BundleCatalogRoundId: '1',
      //   MediumType: '065',
      //   MediumName: '予約商品',
      //   StartOrderCode: '2023160',
      //   EndOrderCode: '2023320',
      //   StartDelivCatalogId: '20230701',
      //   EndDelivCatalogId: '20231004',
      //   BundleCatalogRoundName: '予約商品（７～１０月）',
      //   BundleCatalogRoundCode: '2023030-2023150',
      //   EndDelivCatalogEndDate: '20241220'
      // },
      // {
      //   BundleCatalogRoundId: '1',
      //   MediumType: '065',
      //   MediumName: '予約商品',
      //   StartOrderCode: '2023160',
      //   EndOrderCode: '2023320',
      //   StartDelivCatalogId: '20230701',
      //   EndDelivCatalogId: '20231004',
      //   BundleCatalogRoundName: '予約商品（７～１０月）',
      //   BundleCatalogRoundCode: '2023030-2023150',
      //   EndDelivCatalogEndDate: '20241220'
      // },
    ]
  }
};


const registBundleCatalogRoundInfoResponse: Response<RegistBundleCatalogRoundInfoResponse> = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        BundleCatalogRoundId: '100',
      }
    ]
  }
};

const deleteBundleCatalogRoundInfo: Response<undefined> = {
  status: 'ok',
  message: '処理完了',
};
